//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { props } from './props';
import { defineComponent } from '../utils/create';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "cb-top-three"
  }, _vm._l(_vm.top3List, function (item, index) {
    return _c('div', {
      key: index,
      class: "top3-item top" + (index + 1)
    }, [_c('div', {
      staticClass: "top3-item__avatar-bg"
    }), _vm._v(" "), _c('div', {
      staticClass: "top3-item__avatar-wrapper"
    }, [item && item[_vm.mergedGetter.headphoto] ? [_c('img', {
      staticClass: "top3-item__avatar-wrapper-real",
      attrs: {
        "src": item[_vm.mergedGetter.headphoto]
      },
      on: {
        "click": function ($event) {
          return _vm.handleClickAvatar(item, index);
        }
      }
    })] : _c('div', {
      staticClass: "top3-item__avatar-wrapper-virtual"
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "top3-item__info"
    }, [_c('div', {
      staticClass: "top3-item__info-title"
    }, [_vm._t("title", function () {
      return [_vm._v(_vm._s(item[_vm.mergedGetter.nickname]))];
    }, {
      "item": item,
      "index": index
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "top3-item__info-subtitle"
    }, [_vm._t("subtitle", function () {
      return [_vm._v(_vm._s(item[_vm.mergedGetter.score]))];
    }, {
      "item": item,
      "index": index
    })], 2)]), _vm._v(" "), _vm._t("default", null, {
      "item": item,
      "index": index
    })], 2);
  }), 0);
};
var staticRenderFns = [];
export default defineComponent({
  _scopeId: 'data-v-1b1a8b15',
  render,
  name: 'CbTopThree',
  props,
  computed: {
    top3List() {
      var origin = this.list;
      var arr = origin.slice(0, 3);
      while (arr.length < 3) {
        arr.push({
          rank: null,
          score: 0,
          nickname: '',
          headphoto: ''
        });
      }
      return arr;
    },
    mergedGetter() {
      return Object.assign(this.defaultGetter, this.fieldsGetter);
    }
  },
  data() {
    return {
      defaultGetter: {
        headphoto: 'headphoto',
        nickname: 'nickname',
        score: 'score',
        rank: 'rank'
      }
    };
  },
  methods: {
    // 点击头像抛出事件，交给开发者处理
    handleClickAvatar(item, index) {
      this.$emit('click-avatar', item, index);
    }
  }
});